import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunitiesProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunities = async () => await axiosAuth.get(GET_COMMUNITIES);

const useGetCommunities = ({
  queryParams,
}: UseGetCommunitiesProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["communities"],
    queryFn: () => getCommunities(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetCommunities;
